import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import useMenuLogic from "./Menu.logic";
import useHeaderLogic from "../Header/Header.logic";
import LocationSelector from "../../components/elements/LocationSelector";

type MobileMenuProps = {
  isSidebar: boolean;
  handleSidebar: () => void;
  handleMobileMenu: () => void;
};

const Footer: React.FC<MobileMenuProps> = ({
  isSidebar,
  handleSidebar,
  handleMobileMenu,
}) => {
  const [isActive, setIsActive] = useState({
    status: false,
    key: 0,
    subMenuKey: 0,
  });

  const handleToggle = (key: number, subMenuKey: number = 0) => {
    if (isActive.key === key && isActive.subMenuKey === subMenuKey) {
      setIsActive({
        status: false,
        key: 0,
        subMenuKey: 0,
      });
    } else {
      setIsActive({
        status: true,
        key,
        subMenuKey,
      });
    }
  };

  const {
    isCurrentPath,
    isAuthenticated: menuIsAuthenticated,
    showMyEvents,
    showManageEvents,
    showAdminMenu,
  } = useMenuLogic();

  const {
    user,
    isAuthenticated,
    onLogout,
    isAdmin,
    showAdminPanel,
    setIsAdminPanelState,
  } = useHeaderLogic();

  return (
    <>
      {/*End Mobile Menu */}
      <div className="mobile-nav__wrapper">
        <div
          className="mobile-nav__overlay mobile-nav__toggler"
          onClick={handleMobileMenu}
        />
        {/* /.mobile-nav__overlay */}
        <div className="mobile-nav__content">
          <span
            className="mobile-nav__close mobile-nav__toggler"
            onClick={handleMobileMenu}
          >
            <i className="fa fa-times" />
          </span>
          <div className="logo-box">
            <div className="main-menu__logo">
              <Link to="/">
                <span className="logo_name">ImpactUp</span>
                <span className="slogan_name">
                  Where Passion Meets Purpose.
                </span>
                {/* <img src="/assets/images/resources/logo-1.png" alt="Logo" /> */}
              </Link>
            </div>
            {/* <Link to="/" aria-label="logo image">
              <img
                src="/assets/images/resources/logo-1.png"
                width="150"
                alt="Logo"
              />
            </Link> */}
          </div>

          <div className="mobile-menu__location mb-2">
            <LocationSelector />
          </div>

          {/* /.logo-box */}
          <div className="mobile-nav__container">
            <ul className="main-menu__list">
              <li>
                <Link to="/" onClick={handleMobileMenu}>
                  Home
                </Link>
              </li>
              <li
                className={`${
                  (isCurrentPath("/events") ? "current" : "") +
                  (isAuthenticated ? " dropdown" : "") +
                  (isActive.key === 4 ? "" : "")
                }`}
              >
                <Link to="/events" onClick={handleMobileMenu}>
                  Events
                </Link>
                {isAuthenticated && (
                  <>
                    <ul
                      style={{
                        display: `${isActive.key === 4 ? "block" : "none"}`,
                      }}
                    >
                      <li>
                        <Link
                          to="/events?filter=discover"
                          onClick={handleMobileMenu}
                        >
                          Discover
                        </Link>
                      </li>
                      {showMyEvents && (
                        <li>
                          <Link
                            to="/events?filter=my-events&view=my-events"
                            onClick={handleMobileMenu}
                          >
                            My Events
                          </Link>
                        </li>
                      )}
                      {showManageEvents && (
                        <li>
                          <Link
                            to="/events?filter=admin-events&view=admin-events"
                            onClick={handleMobileMenu}
                          >
                            Manage All Events
                          </Link>
                        </li>
                      )}
                      <li>
                        <Link to="/events/add" onClick={handleMobileMenu}>
                          Host a New Event
                        </Link>
                      </li>
                    </ul>

                    <div
                      className={
                        isActive.key === 4
                          ? "dropdown-btn open"
                          : "dropdown-btn"
                      }
                      onClick={() => handleToggle(4)}
                    >
                      <span className="fa fa-angle-right" />
                    </div>
                  </>
                )}
              </li>
              <li>
                <Link to="/ngos" onClick={handleMobileMenu}>
                  NGOs
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={handleMobileMenu}>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={handleMobileMenu}>
                  Contact Us
                </Link>
              </li>

              {isAuthenticated && (
                <>
                  <li>
                    <Link to="/profile" onClick={handleMobileMenu}>
                      Profile
                    </Link>
                  </li>
                  <li>
                    <Link to="/bookings" onClick={handleMobileMenu}>
                      Bookings
                    </Link>
                  </li>
                  <li>
                    <Link to="/reports" onClick={handleMobileMenu}>
                      Reports
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={() => {
                        onLogout();
                        handleMobileMenu();
                      }}
                      to="#"
                    >
                      Logout
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="fa fa-envelope" />
              <a href="mailto:support@impactup.ai">support@impactup.ai</a>
            </li>
            {/* <li>
              <i className="fa fa-phone-alt" />
              <a href="tel:+1 (201) 555-0134">+1 (201) 555-0134</a>
            </li> */}
          </ul>
          {/* /.mobile-nav__contact */}
          {/* <div className="mobile-nav__top">
            <div className="mobile-nav__social">
              <a href="#" className="fab fa-facebook-square" />
              <a href="#" className="fab fa-twitter" />
              <a href="#" className="fab fa-instagram" />
            </div>
          </div> */}
          {/* /.mobile-nav__top */}

          <div className="mobile-nav__buttons">
            <Link
              to="/ngos"
              onClick={handleMobileMenu}
              className="thm-btn small_btn m-0"
            >
              Donate Now
            </Link>
          </div>
        </div>
        {/* /.mobile-nav__content */}
      </div>

      <div
        className="nav-overlay"
        style={{ display: `${isSidebar ? "block" : "none"}` }}
        onClick={handleSidebar}
      />
    </>
  );
};

export default Footer;
